// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"ButtonWrapper_button-wrapper__ZIGj1"};